module.exports = __webpack_public_path__ + "379dd6fc9f932b1e109e058c742a03bc.svg";